/**
 * @param {string} brand - The brand identifier (e.g., 'simplecasino', 'simplecasino24')
 * @param {string} key - The original translation key
 * @returns {string} The translation key with brand prefix if brand is 'simplecasino24', otherwise returns original key
 */
export function getTranslationKey(brand, key) {
  return brand === 'simplecasino24' ? `simplecasino24.${key}` : key
}
